import {HTMLAttributes} from 'react';
import {t} from '../common/getTranslations';
import {ErrorArea} from '../design-system/organisms/ErrorArea/ErrorArea';

interface NetworkErrorProps extends HTMLAttributes<HTMLDivElement> {
  isMobile: boolean;
  onClickRetry?: () => void;
}

export function NetworkError({
  isMobile,
  onClickRetry,
  ...props
}: NetworkErrorProps) {
  return (
    <ErrorArea isMobile={isMobile} {...props}>
      <ErrorArea.Title>{t('error_network_title')}</ErrorArea.Title>
      <ErrorArea.MainText>
        {t('error_network_connect_check')}
      </ErrorArea.MainText>
      {onClickRetry && (
        <ErrorArea.LabelButton onClick={onClickRetry}>
          {t('error_retry_button')}
        </ErrorArea.LabelButton>
      )}
    </ErrorArea>
  );
}
